import { Box } from '@mui/material';
import React from 'react';
export const FileManagerWrapper = ({ children }) => {
    return React.createElement(Box, { p: 4 },
        " ",
        children,
        " ");
};
